import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $navbarStaticTitles = combine(i18n.$t, ({ t }) => ({
  more: t('more'),
}))

export const $navbarDropDownTitles = combine(i18n.$t, ({ t }) => ({
  signIn: t('sign_in'),
  logOut: t('log_out'),
  settings: t('settings'),
  myList: t('my_list'),
  accountSettings: t('account_settings'),
}))
